import { render, staticRenderFns } from "./OrganizationDocuments.vue?vue&type=template&id=27777c0a&scoped=true"
import script from "./OrganizationDocuments.vue?vue&type=script&lang=js"
export * from "./OrganizationDocuments.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDocuments.vue?vue&type=style&index=0&id=27777c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27777c0a",
  null
  
)

export default component.exports